import React, { useState } from 'react';
import { TextField, Grid, Chip } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import Autocomplete from '@mui/material/Autocomplete';

export default function HandleOptions(data) {
  const [options, setOptions] = useState(data.options);

  function checkRepeatedItems(item) {
    return options.some((option) => option?.description === item);
  }

  const valHtml = options.map((option, index) => {
    const label = option.description || option;
    return (
      <Chip
        title="Excluir"
        style={{
          marginTop: 5,
          marginRight: 5,
          fontSize: 16,
          fontWeight: 'bold',
        }}
        key={label}
        label={label}
        deleteIcon={<RemoveIcon />}
        onDelete={() => {
          if (option.isUsade) return false;

          if (options.length <= 1) {
            setOptions([]);
            data.callback([]);
            return;
          }

          const newOptions = [...options];
          newOptions.splice(index, 1);

          setOptions(newOptions);
          data.callback(newOptions);
        }}
        disabled={option.isUsade}
      />
    );
  });

  return (
    <Grid item xs>
      <Autocomplete
        multiple
        id="tags-standard"
        freeSolo
        filterSelectedOptions
        options={[]}
        onChange={(e) => {
          const option = e.target.value;
          const isItRepeatedItem = checkRepeatedItems(option);

          if (!isItRepeatedItem) {
            setOptions([...options, { description: option }]);
            data.callback([...options, { description: option }]);
          }
        }}
        getOptionLabel={(option) => option.title}
        renderTags={() => { }}
        value={options}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Digite o texto e aperte Enter para adicionar"
            margin="normal"
            fullWidth
            error={
              !!(data.errors[0] && data.errors[1] && data.options.length === 0)
            }
            helperText={data.errors[0] && data.errors[1]}
          />
        )}
      />
      <div className="selectedTags">{valHtml}</div>
    </Grid>
  );
}
